import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import React from 'react';
import { useParams } from 'react-router';
import { Headers, TaskSection } from 'shared/components/ui/task-section';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useActiveTaskId } from 'shared/contexts/task-detail';
import { TypeSections } from 'shared/types/page-sections';

import { useTagTypeTaskSections } from '../../hooks/use-tag-type-task-sections';
import * as Styled from './type-grouping-tasks-list.style';

export const TypeGroupingTasksList: React.FC = () => {
  const { id } = useParams();
  const { sections } = useTagTypeTaskSections(id);

  const openPremiumDialog = useOpenPremiumDialog();

  const selectedTask = useActiveTaskId();

  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();

  return (
    <Styled.Container>
      {sections.map((section) => (
        <Styled.Section key={section.id}>
          <TaskSection
            goals={goals}
            lifeAreas={lifeAreas}
            onPremium={openPremiumDialog}
            tasks={section.items}
            tagIds={id ? [id] : undefined}
            selectedTask={selectedTask}
            headerToDisplay={Headers.Type}
            type={section.id}
            canCreateTask={section.id !== TypeSections.Habits}
            canCreateHabit={section.id === TypeSections.Habits}
            canCollapse
          />
        </Styled.Section>
      ))}
    </Styled.Container>
  );
};
